import React, { useMemo, useEffect } from 'react';
import { FormStatus, reservationQuery } from '@lib/state';
import {
  ReservationRouteProps,
  useClaimReservation,
  LoadingIndicator,
  useObservable,
  ErrorDisplay,
} from '@lib/common';

export const ClaimReservationPage: React.FC<ReservationRouteProps> = ({
  match,
  history,
  location,
}) => {
  const reservationId = match.params['reservationId'];

  const code = useMemo(() => {
    const query = new URLSearchParams(location.search);
    const value = query.get('code');
    return value ? parseInt(value) : 0;
  }, [location.search]);

  const claimGuests = useObservable(reservationQuery.claimGuests);

  const [status, error] = useClaimReservation(reservationId, code, claimGuests);

  useEffect(() => {
    if (status === FormStatus.Success) {
      history.push(`/profile/stays`);
    }
  }, [status, history]);

  if (status === FormStatus.Error) {
    return <ErrorDisplay error={error} />;
  }

  return <LoadingIndicator loadingText="Claiming Reservation..." fillContainer />;
};
